<template>
  <div style="position: relative">
    <Row class="scoped-order">
      <Col :span="12">
        <div class="money">{{ info.addWeight }}</div>
        <div class="title">{{ $t('name.cex.addWeight') }}</div>
      </Col>
      <Col :span="12">
        <div class="money">{{ info.addPrice | money }}</div>
        <div class="title">{{ $t('name.cex.addPrice') }}</div>
      </Col>
    </Row>
    <Row class="scoped-order">
      <Col :span="12">
        <div class="money">{{ info.insure | money }}</div>
        <div class="title">{{ $t('name.cex.insure') }}</div>
      </Col>
      <Col :span="12">
        <div class="money">{{ info.collect | money }}</div>
        <div class="title">{{ $t('name.cex.collect') }}</div>
      </Col>
    </Row>
    <Row class="scoped-order">
      <Col :span="12">
        <div class="money">{{ info.price | money }}</div>
        <div class="title">{{ $t('name.cex.price') }}</div>
      </Col>
      <Col :span="12">
        <div class="money color">{{ info.money | money }}</div>
        <div class="title">{{ $t('name.cex.money') }}</div>
      </Col>
    </Row>
    <div class="scoped-order">
      <Button size="large" @click="$emit('order', false)">{{ $t('name.cex.button_order') }}</Button><Divider type="vertical" />
      <Button type="primary" size="large" @click="$emit('order', true)">{{ $t('name.cex.button_order_ok') }}</Button>
    </div>
    <Spin size="large" v-if="loading" fix />
  </div>
</template>
<script>
import { money, order } from '@/api/cex'

export default {
  props: {
    id: Number,
    form: Object
  },
  data() {
    return {
      loading: true,
      info: {}
    }
  },
  methods: {
    // 获取价格
    get() {
      this.$nextTick(() => {
        this.loading = true
        money(this.id, this.form).then(res => {
          this.info = res
          this.loading = false
        }).catch(res => {
          this.$Message.error(this.$t('message.' + res.message))
        })
      })
    },
    
    // 开始下单
    start() {
      return new Promise(resolve => {
        this.loading = true
        order(this.id, this.form).then(order => {
          this.loading = false
          resolve(order)
        }).catch(res => {
          this.loading = false
          this.$Message.error(this.$t('message.' + res.message))
          resolve(false)
        })
      });
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';

  .scoped-order{
    padding-bottom: 25px;
    text-align: center;

    .money{
      color: @color-content;
      font-size: 20px;
      line-height: 30px;
      
      &.color{
        color: @color;
      }
    }
    
    .title{
      color: @color-sub;
      font-size: 14px;
      line-height: 25px;
    }
  }
</style>